<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-row>
        <el-col :span="6">
          <el-button
            type="primary"
            v-role="['1', '3']"
            class="add"
            v-if="isAllowed"
            size="small"
            @click="addTeam"
          >
            <i class="el-icon-plus"></i>
            新增代表队
          </el-button>
          <el-button
            type="danger"
            size="small"
            v-role="['1']"
            class="delete"
            @click="delMulData"
          >
            <i class="el-icon-delete"></i>删除
          </el-button>
          <el-button
            type="success"
            size="small"
            class="delete"
            v-role="['1', '3']"
            @click="downLoad"
          >
            <i class="el-icon-download"></i>下载
          </el-button>
        </el-col>
        <el-col :span="18" style="text-align: right">
          <el-button
            type="success"
            plain
            v-role="['1']"
            size="small"
            @click="enableAllRegister"
            >全部允许在线报名</el-button
          >
          <el-button
            type="danger"
            plain
            v-role="['1']"
            size="small"
            @click="disableAllRegister"
            >全部禁止在线报名</el-button
          >
          <el-button
            type="warning"
            plain
            v-role="['1']"
            size="small"
            @click="enablePartRegister"
            >单个允许在线报名</el-button
          >
          <el-button
            type="info"
            plain
            v-role="['1']"
            size="small"
            @click="disablePartRegister"
            >单个禁止在线报名</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入代表队名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      :show-summary="true"
      :summary-method="getSummaries"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="代表队名称"
        :formatter="teamNameFormatter"
      ></el-table-column>
      <el-table-column
        prop="caption"
        align="center"
        label="领队"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        align="center"
        label="电话"
      ></el-table-column>
      <el-table-column
        prop="isAllowRegister"
        align="center"
        label="在线报名"
        :formatter="isAllowRegisterFormatter"
      ></el-table-column>
      <el-table-column
        prop="playerNumber"
        align="center"
        label="人数"
      ></el-table-column>
      <el-table-column
        prop="playerCount"
        align="center"
        label="人次"
      ></el-table-column>
      <el-table-column
        prop="entryFee" v-if="isSepecialUserHidden()"
        align="center"
        label="报名费"
      ></el-table-column>
      <el-table-column prop="feeAmount" v-if="isShowRebate"  align="center"
        label="返点">
      </el-table-column>
        <el-table-column v-if="isShowRebate"  align="center"
        label="实收" :formatter="amountFormatter">
        
      </el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="200"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-row>
            <el-col :span="12">
              <el-button
                type="primary"
                @click="deleteTeam(scope.row)"
                 v-role="['1']"
                class="btn"
                size="small"
                >删除</el-button
              ></el-col
            >
            <el-col :span="12">
              <el-popover
                trigger="click"
                title="更改代表队排序"
                v-if="isHostOrAdmin()"
                placement="top"
              >
                <el-form>
                  <el-form-item>
                    <el-input-number
                      :controls="false"
                      v-model="sequence"
                      :value="scope.row.sequence"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="isUpdateAll"
                      >是否更新后续序号</el-checkbox
                    >
                  </el-form-item>
                </el-form>
                <div style="text-align: right; margin: 0">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="changeSequence(scope.row.id)"
                    >确定</el-button
                  >
                </div>
                <div slot="reference" class="name-wrapper">
                  <el-button type="danger" size="small">排序</el-button>
                </div>
              </el-popover>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
     <div v-if="isShowRebate"  style="margin-bottom: 10px">
      <span>合计：</span
      ><span style="color: red">{{ totalAmount }}</span> &nbsp;&nbsp;<span        
        >返点：</span
      ><span style="color: red">{{ rebeateAmount }}</span>
      &nbsp;&nbsp;<span        
        >实收金额：</span
      ><span style="color: red">{{ totalAmount-rebeateAmount }}</span>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'新增代表队'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="form.account" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="form.confirmPassword"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="代表队名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="领队" prop="caption">
          <el-input v-model="form.caption" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="教练" prop="coach">
          <el-input v-model="form.coach" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/teamMatch'
import Host from '../apis/host'
import PMAPI from '../apis/playermatch'
import MAPI from '../apis/match'


export default {
  props: ['matchId'],
  data () {
    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.password !== '') {
          this.$refs.form.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
       totalAmount: 0,
      rebeateAmount: 0,
      isLoading: false,
      isShowRebate:false,
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      isAllowed: false,
      tableListData: [],
      sequence: 0,
      isUpdateAll: false,
      searchForm: {
        matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
      summaryModel: {
        playerNumber: 0, playerCount: 0, totalAmount: 0
      },
      form: {
        id: 0,
        name: '',
        caption: '',
        coach: '',
        mobile: '',
        account: null,
        password: null,
        confirmPassword: null,
        matchId: this.matchId
      },
      formRules: {
        account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' },
        { validator: validatePass3, trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' },
        { validator: validatePass4, trigger: 'blur' }],
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        caption: [{ required: true, message: '请输入领队', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      }
    }
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    amountFormatter(row,column){
      return row.entryFee-row.feeAmount;
    },
    teamNameFormatter (row, column) {
      return row.sequence.toString().padStart(3, '0') + row.name
    },
    changeSequence (id) {
      API.changeSequence({ id: id, sequence: this.sequence, isUpdateAll: this.isUpdateAll, matchId: this.matchId }).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.search()
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        else if (column.property == 'playerNumber') {
          sums[index] = this.summaryModel.playerNumber
        }
        else if (column.property == 'playerCount') {
          sums[index] = this.summaryModel.playerCount
        }
        else if (column.property == 'entryFee') {
          sums[index] = this.summaryModel.totalAmount
        }
        else {
          sums[index] = ''
        }
      });

      return sums;
    },
    isAllowRegisterFormatter (row, column) {
      return row.isAllowRegister ? '允许' : '禁止'
    },
    editTeam (row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    addTeam () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    enableAllRegister () {
      let that = this;
      this.$confirm('此操作将允许代表队在线报名，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        API.enableAll({ matchId: that.matchId }).then(function (result) {
          if (result && result.code == 0) {
            that.$message.success({ showClose: true, message: '已经允许代表队在线报名', duration: 2000 });
            that.search()
          } else {
            that.$message.error({ showClose: true, message: '操作异常，请重试', duration: 2000 });
          }
        }, function (err) {
          that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
        }).catch(function (error) {
          that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
        })
      })
    },
    disableAllRegister () {
      let that = this;
      this.$confirm('此操作将禁止代表队在线报名，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        API.disableAll({ matchId: that.matchId }).then(function (result) {
          if (result && result.code == 0) {
            that.$message.success({ showClose: true, message: '已经禁止代表队在线报名', duration: 2000 });
            that.search()
          } else {
            that.$message.error({ showClose: true, message: '操作异常，请重试', duration: 2000 });
          }
        }, function (err) {
          that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
        }).catch(function (error) {
          that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
        })
      })
    },
    enablePartRegister () {
      let that = this;
      let val = that.multipleSelection
      if (this.multipleSelection == null || this.multipleSelection.length < 1) {
        this.$message.error({ showClose: true, message: '请选择要允许报名的代表队', duration: 2000 });
        return;
      }
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将允许代表队在线报名，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.enablePart({ ids: idArray, matchId: that.matchId }).then(function (result) {
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '已经允许代表队在线报名', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    },
    disablePartRegister () {
      let that = this;
      let val = that.multipleSelection
      if (this.multipleSelection == null || this.multipleSelection.length < 1) {
        this.$message.error({ showClose: true, message: '请选择要禁止的代表队', duration: 2000 });
        return;
      }
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将禁止代表队在线报名，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.disablePart({ ids: idArray, matchId: that.matchId }).then(function (result) {
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '已经禁止代表队在线报名', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      PMAPI.total({ matchId: this.matchId }).then(res => {
        if (res != null && res.code == 0) {
          if (res.result.total) {
            this.totalAmount = res.result.total
          }
            this.rebeateAmount = res.result.rebate;
        }
      })
      API.summary({ matchId: this.matchId }).then(res => {
        this.summaryModel = res.result
      })
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.register(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    deleteTeam (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          console.log(result)
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: result.message, duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '系统错误', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: result.message, duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    },
    isHostOrAdmin () {
      return sessionStorage.getItem('userType') == "3" || sessionStorage.getItem('userType') == "1"
    },
    isSepecialUserHidden(){
      if( sessionStorage.getItem('uid')==='2077')
      {
        return false;
      }
      return true;
    },
    downLoad: function () {
      API.download({ matchId: this.matchId }).then(res => {
        var content = res;
        var blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var fileName = "代表队.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
  computed: {
  },
  mounted () {
    MAPI.get({id:this.matchId}).then(res=>{
      this.isShowRebate=res.result.isShowRebate
      if( sessionStorage.getItem('uid')==='2077')
      {
        this.isShowRebate=false;
      }
    });
    this.search()
    Host.getUser().then(res => {
      this.isAllowed = res.result || sessionStorage.getItem('userType') == "1"
    })
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Team.vue